import apiClient from '../apiClient';
import { UPLOAD_COMMIT_TRANSPORTATION_UNIT_URL } from '../apiUrl';

const uploadMasterTransportationUnitApi = data => {
  return apiClient.post(UPLOAD_COMMIT_TRANSPORTATION_UNIT_URL, data);
};

export default uploadMasterTransportationUnitApi;
